import React from "react";
import { observer } from "mobx-react-lite";
import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views";
import DetailView from "views/common/detailView";
import { formatAmount } from "utils/localizations";
import SectionWrapper from "./cardGatewaySectionView";
import PaymentCardGatewayDetailViewModel from "viewModels/finance/payments/cardGateWay/paymentCardGatewayDetailViewModel";

const CardGatewayDetailView: ViewComponent<PaymentCardGatewayDetailViewModel> = observer(({ vm }) => {
  const amount = vm.item?.bruttoAmount ? formatAmount(vm.item.bruttoAmount) : 0;
  const amountTextClass = vm.isAmountPositive ? "success" : "danger";
  const titleInfo = (
    <div className="mb-3" style={{ fontSize: "1.25rem" }}>
      <span>{vm.variableSymbol}</span>
      <span> / </span>
      <span className={`text-${amountTextClass}`}>{amount}</span>
    </div>
  );

  return (
    <DetailView
      vm={vm}
      titleInfo={titleInfo}
      form={<SectionWrapper vm={vm} />}
      customBackButtonText={vm.translate("backButton")}
    />
  );
});

registerView(CardGatewayDetailView, PaymentCardGatewayDetailViewModel);
